import { Dispatch, SetStateAction } from "react";
import {
  IAddress,
  ICommitteeMemberInput,
  ICooperativeDetails,
  IDeclaration,
  IDocumentsInput,
  IExecutiveMemberInput,
  IFinancialAuditInput,
  IFinancialIncome,
  IFinancialLoan,
  IFinancialShare,
  IFinancialTax,
  IShareMemberInput,
} from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import { base64ToFile, fileToBase64 } from "../../exports/functions";

export const saveToLocalStorage = async (
  currentStep: number,
  cooperativeInfo: ICooperativeDetails,
  address: IAddress,
  shareFinancial: IFinancialShare,
  loanFinancial: IFinancialLoan,
  incomeFinancial: IFinancialIncome,
  auditFinancial: IFinancialAuditInput,
  taxFinancial: IFinancialTax,
  committeeCooperative: ICommitteeMemberInput,
  executiveCooperative: IExecutiveMemberInput,
  committeeTableCooperative: ICommitteeMemberInput[],
  executiveTableCooperative: IExecutiveMemberInput[],
  shareMember: IShareMemberInput,
  declaration: IDeclaration,
  documents: IDocumentsInput,
) => {
  if (currentStep === 0) {
    const dataToSave = {
      formData: {
        ...cooperativeInfo,
      },
    };
    try {
      localStorage.setItem("cooperative", JSON.stringify(dataToSave));
    } catch {
      dynamicFailed("Failed to save draft.");
    }
  } else if (currentStep === 1) {
    const dataToSave = {
      formData: {
        ...address,
      },
    };
    try {
      localStorage.setItem("address", JSON.stringify(dataToSave));
    } catch {
      dynamicFailed("Failed to save draft.");
    }
  } else if (currentStep === 2) {
    const shareDataToSave = {
      formData: {
        ...shareFinancial,
      },
    };
    const loanDataToSave = {
      formData: {
        ...loanFinancial,
      },
    };
    const incomeDataToSave = {
      formData: {
        ...incomeFinancial,
      },
    };
    const auditDataToSave = {
      formData: {
        ...auditFinancial,
        file: auditFinancial.file
          ? await fileToBase64(auditFinancial.file)
          : null,
      },
    };
    const taxDataToSave = {
      formData: {
        ...taxFinancial,
      },
    };
    try {
      localStorage.setItem("shareFinancial", JSON.stringify(shareDataToSave));
      localStorage.setItem("loanFinancial", JSON.stringify(loanDataToSave));
      localStorage.setItem("incomeFinancial", JSON.stringify(incomeDataToSave));
      localStorage.setItem("auditFinancial", JSON.stringify(auditDataToSave));
      localStorage.setItem("taxFinancial", JSON.stringify(taxDataToSave));
    } catch {
      dynamicFailed("Failed to save draft.");
    }
  } else if (currentStep === 3) {
    const committeeDataToSave = {
      formData: {
        ...committeeCooperative,
        file: committeeCooperative.file
          ? await fileToBase64(committeeCooperative.file)
          : null,
        bodFile: committeeCooperative.bodFile
          ? await fileToBase64(committeeCooperative.bodFile)
          : null,
        citizenshipFront: committeeCooperative.citizenshipFront
          ? await fileToBase64(committeeCooperative.citizenshipFront)
          : null,
        citizenshipBack: committeeCooperative.citizenshipBack
          ? await fileToBase64(committeeCooperative.citizenshipBack)
          : null,
      },
    };

    const executiveDataToSave = {
      formData: {
        ...executiveCooperative,
        file: executiveCooperative.file
          ? await fileToBase64(executiveCooperative.file)
          : null,
        citizenshipFront: executiveCooperative.citizenshipFront
          ? await fileToBase64(executiveCooperative.citizenshipFront)
          : null,
        citizenshipBack: executiveCooperative.citizenshipBack
          ? await fileToBase64(executiveCooperative.citizenshipBack)
          : null,
      },
    };

    const committeeTableDataToSave = {
      formData: await Promise.all(
        committeeTableCooperative.map(async (member) => ({
          ...member,
          file: member.file ? await fileToBase64(member.file) : null,
          bodFile: member.bodFile ? await fileToBase64(member.bodFile) : null,
          citizenshipFront: member.citizenshipFront
            ? await fileToBase64(member.citizenshipFront)
            : null,
          citizenshipBack: member.citizenshipBack
            ? await fileToBase64(member.citizenshipBack)
            : null,
        })),
      ),
    };

    const executiveTableDataToSave = {
      formData: await Promise.all(
        executiveTableCooperative.map(async (member) => ({
          ...member,
          file: member.file ? await fileToBase64(member.file) : null,
          citizenshipFront: member.citizenshipFront
            ? await fileToBase64(member.citizenshipFront)
            : null,
          citizenshipBack: member.citizenshipBack
            ? await fileToBase64(member.citizenshipBack)
            : null,
        })),
      ),
    };

    try {
      localStorage.setItem(
        "committeeCooperative",
        JSON.stringify(committeeDataToSave),
      );

      localStorage.setItem(
        "executiveCooperative",
        JSON.stringify(executiveDataToSave),
      );
      localStorage.setItem(
        "committeeTableCooperative",
        JSON.stringify(committeeTableDataToSave),
      );

      localStorage.setItem(
        "executiveTableCooperative",
        JSON.stringify(executiveTableDataToSave),
      );
    } catch {
      dynamicFailed("Failed to save draft.");
    }
  } else if (currentStep === 4) {
    const shareMemberDataToSave = {
      formData: {
        ...shareMember,

        shareMemberFile: shareMember.shareMemberFile
          ? await fileToBase64(shareMember.shareMemberFile)
          : null,

        savingMemberFile: shareMember.savingMemberFile
          ? await fileToBase64(shareMember.savingMemberFile)
          : null,

        loanMemberFile: shareMember.loanMemberFile
          ? await fileToBase64(shareMember.loanMemberFile)
          : null,
      },
    };

    try {
      localStorage.setItem(
        "shareMember",
        JSON.stringify(shareMemberDataToSave),
      );
    } catch {
      dynamicFailed("Failed to save draft.");
    }
  } else if (currentStep === 5) {
    const documentsDataToSave = {
      formData: {
        ...documents,

        regCertificateFile: documents.regCertificateFile
          ? await fileToBase64(documents.regCertificateFile)
          : null,

        lawDocumentFile: documents.lawDocumentFile
          ? await fileToBase64(documents.lawDocumentFile)
          : null,

        foundingDocumentFile: documents.foundingDocumentFile
          ? await fileToBase64(documents.foundingDocumentFile)
          : null,

        panDocumentFile: documents.panDocumentFile
          ? await fileToBase64(documents.panDocumentFile)
          : null,

        meetingDocumentFile: documents.meetingDocumentFile
          ? await fileToBase64(documents.meetingDocumentFile)
          : null,

        businessRegistrationFile: documents.businessRegistrationFile
          ? await fileToBase64(documents.businessRegistrationFile)
          : null,

        taxClearanceFile: documents.taxClearanceFile
          ? await fileToBase64(documents.taxClearanceFile)
          : null,

        agmDocumentFile: documents.agmDocumentFile
          ? await fileToBase64(documents.agmDocumentFile)
          : null,

        otherDocumentFile: documents.otherDocumentFile
          ? await fileToBase64(documents.otherDocumentFile)
          : null,
      },
    };

    try {
      localStorage.setItem("documents", JSON.stringify(documentsDataToSave));
    } catch {
      dynamicFailed("Failed to save draft.");
    }
  } else if (currentStep === 6) {
    const declarationDataToSave = {
      formData: {
        ...declaration,
      },
    };

    try {
      localStorage.setItem(
        "declaration",
        JSON.stringify(declarationDataToSave),
      );
    } catch {
      dynamicFailed("Failed to save draft.");
    }
  }
};

export const loadRegisterData = async (
  currentStep: number,
  setCooperativeInfo: Dispatch<SetStateAction<ICooperativeDetails>>,
  setAddress: Dispatch<SetStateAction<IAddress>>,
  setShareFinancial: Dispatch<SetStateAction<IFinancialShare>>,
  setLoanFinancial: Dispatch<SetStateAction<IFinancialLoan>>,
  setIncomeFinancial: Dispatch<SetStateAction<IFinancialIncome>>,
  setAuditFinancial: Dispatch<SetStateAction<IFinancialAuditInput>>,
  setTaxFinancial: Dispatch<SetStateAction<IFinancialTax>>,
  setCommitteeCooperative: Dispatch<SetStateAction<ICommitteeMemberInput>>,
  setExecutiveCooperative: Dispatch<SetStateAction<IExecutiveMemberInput>>,
  setCommitteeTableCooperative: Dispatch<SetStateAction<ICommitteeMemberInput[]>>,
  setExecutiveTableCooperative: Dispatch<SetStateAction<IExecutiveMemberInput[]>>,
  setShareMember: Dispatch<SetStateAction<IShareMemberInput>>,
  setDeclaration: Dispatch<SetStateAction<IDeclaration>>,
  setDocuments: Dispatch<SetStateAction<IDocumentsInput>>,
) => {
  if (currentStep === 0) {
    const savedData = localStorage.getItem("cooperative");
    if (!savedData) return;
    const parsedData = JSON.parse(savedData);
    const savedFormData = parsedData.formData;
    setCooperativeInfo({
      ...savedFormData,
    });
  } else if (currentStep === 1) {
    const savedData = localStorage.getItem("address");
    if (!savedData) return;
    const parsedData = JSON.parse(savedData);
    const savedFormData = parsedData.formData;
    setAddress({
      ...savedFormData,
    });
  } else if (currentStep === 2) {
    const savedShareData = localStorage.getItem("shareFinancial");
    const savedLoanData = localStorage.getItem("loanFinancial");
    const savedIncomeData = localStorage.getItem("incomeFinancial");
    const savedAuditData = localStorage.getItem("auditFinancial");
    const savedTaxData = localStorage.getItem("taxFinancial");

    if (savedShareData) {
      const parsedShareData = JSON.parse(savedShareData);
      const savedFormData = parsedShareData.formData;
      setShareFinancial({
        ...savedFormData,
      });
    }
    if (savedLoanData) {
      const parsedLoanData = JSON.parse(savedLoanData);
      const savedFormData = parsedLoanData.formData;
      setLoanFinancial({
        ...savedFormData,
      });
    }
    if (savedIncomeData) {
      const parsedIncomeData = JSON.parse(savedIncomeData);
      const savedFormData = parsedIncomeData.formData;
      setIncomeFinancial({
        ...savedFormData,
      });
    }
    if (savedAuditData) {
      const parsedIncomeData = JSON.parse(savedAuditData);
      const savedFormData = parsedIncomeData.formData;
      setAuditFinancial({
        ...savedFormData,
        file: savedFormData.file
          ? await base64ToFile(
              savedFormData.file.base64,
              savedFormData.file.name,
              savedFormData.file.type,
            )
          : null,
      });
    }
    if (savedTaxData) {
      const parsedTaxData = JSON.parse(savedTaxData);
      const savedFormData = parsedTaxData.formData;
      setTaxFinancial({
        ...savedFormData,
      });
    }
  } else if (currentStep === 3) {
    const savedCommitteeData = localStorage.getItem("committeeCooperative");
    const savedExecutiveData = localStorage.getItem("executiveCooperative");

    const savedTableCommitteeData = localStorage.getItem(
      "committeeTableCooperative",
    );
    const savedTableExecutiveData = localStorage.getItem(
      "executiveTableCooperative",
    );

    if (savedCommitteeData) {
      const parsedCommitteeData = JSON.parse(savedCommitteeData);
      const savedFormData = parsedCommitteeData.formData;

      setCommitteeCooperative({
        ...savedFormData,
        file: savedFormData.file
          ? await base64ToFile(
              savedFormData.file.base64,
              savedFormData.file.name,
              savedFormData.file.type,
            )
          : null,
        bodFile: savedFormData.bodFile
          ? await base64ToFile(
              savedFormData.bodFile.base64,
              savedFormData.bodFile.name,
              savedFormData.bodFile.type,
            )
          : null,
        citizenshipFront: savedFormData.citizenshipFront
          ? await base64ToFile(
              savedFormData.citizenshipFront.base64,
              savedFormData.citizenshipFront.name,
              savedFormData.citizenshipFront.type,
            )
          : null,
        citizenshipBack: savedFormData.citizenshipBack
          ? await base64ToFile(
              savedFormData.citizenshipBack.base64,
              savedFormData.citizenshipBack.name,
              savedFormData.citizenshipBack.type,
            )
          : null,
      });
    }

    if (savedExecutiveData) {
      const parsedExecutiveData = JSON.parse(savedExecutiveData);
      const savedFormData = parsedExecutiveData.formData;

      setExecutiveCooperative({
        ...savedFormData,
        file: savedFormData.file
          ? await base64ToFile(
              savedFormData.file.base64,
              savedFormData.file.name,
              savedFormData.file.type,
            )
          : null,
        citizenshipFront: savedFormData.citizenshipFront
          ? await base64ToFile(
              savedFormData.citizenshipFront.base64,
              savedFormData.citizenshipFront.name,
              savedFormData.citizenshipFront.type,
            )
          : null,
        citizenshipBack: savedFormData.citizenshipBack
          ? await base64ToFile(
              savedFormData.citizenshipBack.base64,
              savedFormData.citizenshipBack.name,
              savedFormData.citizenshipBack.type,
            )
          : null,
      });
    }

    if (savedTableCommitteeData) {
      const parsed = JSON.parse(savedTableCommitteeData);

      const committeeData = await Promise.all(
        parsed.formData.map(async (member: any) => ({
          ...member,
          file: member.file
            ? await base64ToFile(
                member.file.base64,
                member.file.name,
                member.file.type,
              )
            : null,
          bodFile: member.bodFile
            ? await base64ToFile(
                member.bodFile.base64,
                member.bodFile.name,
                member.bodFile.type,
              )
            : null,
          citizenshipFront: member.citizenshipFront
            ? await base64ToFile(
                member.citizenshipFront.base64,
                member.citizenshipFront.name,
                member.citizenshipFront.type,
              )
            : null,
          citizenshipBack: member.citizenshipBack
            ? await base64ToFile(
                member.citizenshipBack.base64,
                member.citizenshipBack.name,
                member.citizenshipBack.type,
              )
            : null,
        })),
      );

      setCommitteeTableCooperative(committeeData);
    }

    if (savedTableExecutiveData) {
      const parsed = JSON.parse(savedTableExecutiveData);

      const executiveData = await Promise.all(
        parsed.formData.map(async (member: any) => ({
          ...member,
          file: member.file
            ? await base64ToFile(
                member.file.base64,
                member.file.name,
                member.file.type,
              )
            : null,
          citizenshipFront: member.citizenshipFront
            ? await base64ToFile(
                member.citizenshipFront.base64,
                member.citizenshipFront.name,
                member.citizenshipFront.type,
              )
            : null,
          citizenshipBack: member.citizenshipBack
            ? await base64ToFile(
                member.citizenshipBack.base64,
                member.citizenshipBack.name,
                member.citizenshipBack.type,
              )
            : null,
        })),
      );

      setExecutiveTableCooperative(executiveData);
    }
  } else if (currentStep === 4) {
    const savedShareMemberData = localStorage.getItem("shareMember");

    if (savedShareMemberData) {
      const parsedShareMemberData = JSON.parse(savedShareMemberData);
      const savedFormData = parsedShareMemberData.formData;

      setShareMember({
        ...savedFormData,

        shareMemberFile: savedFormData.shareMemberFile
          ? await base64ToFile(
              savedFormData.shareMemberFile.base64,
              savedFormData.shareMemberFile.name,
              savedFormData.shareMemberFile.type,
            )
          : null,

        savingMemberFile: savedFormData.savingMemberFile
          ? await base64ToFile(
              savedFormData.savingMemberFile.base64,
              savedFormData.savingMemberFile.name,
              savedFormData.savingMemberFile.type,
            )
          : null,

        loanMemberFile: savedFormData.loanMemberFile
          ? await base64ToFile(
              savedFormData.loanMemberFile.base64,
              savedFormData.loanMemberFile.name,
              savedFormData.loanMemberFile.type,
            )
          : null,
      });
    }
  } else if (currentStep === 5) {
    const savedDocumentsData = localStorage.getItem("documents");

    if (!savedDocumentsData) return;

    const parsedDocumentsData = JSON.parse(savedDocumentsData);
    const savedFormData = parsedDocumentsData.formData;

    setDocuments({
      ...savedFormData,

      regCertificateFile: savedFormData.regCertificateFile
        ? await base64ToFile(
            savedFormData.regCertificateFile.base64,
            savedFormData.regCertificateFile.name,
            savedFormData.regCertificateFile.type,
          )
        : null,

      lawDocumentFile: savedFormData.lawDocumentFile
        ? await base64ToFile(
            savedFormData.lawDocumentFile.base64,
            savedFormData.lawDocumentFile.name,
            savedFormData.lawDocumentFile.type,
          )
        : null,

      foundingDocumentFile: savedFormData.foundingDocumentFile
        ? await base64ToFile(
            savedFormData.foundingDocumentFile.base64,
            savedFormData.foundingDocumentFile.name,
            savedFormData.foundingDocumentFile.type,
          )
        : null,

      panDocumentFile: savedFormData.panDocumentFile
        ? await base64ToFile(
            savedFormData.panDocumentFile.base64,
            savedFormData.panDocumentFile.name,
            savedFormData.panDocumentFile.type,
          )
        : null,

      meetingDocumentFile: savedFormData.meetingDocumentFile
        ? await base64ToFile(
            savedFormData.meetingDocumentFile.base64,
            savedFormData.meetingDocumentFile.name,
            savedFormData.meetingDocumentFile.type,
          )
        : null,

      businessRegistrationFile: savedFormData.businessRegistrationFile
        ? await base64ToFile(
            savedFormData.businessRegistrationFile.base64,
            savedFormData.businessRegistrationFile.name,
            savedFormData.businessRegistrationFile.type,
          )
        : null,

      taxClearanceFile: savedFormData.taxClearanceFile
        ? await base64ToFile(
            savedFormData.taxClearanceFile.base64,
            savedFormData.taxClearanceFile.name,
            savedFormData.taxClearanceFile.type,
          )
        : null,

      agmDocumentFile: savedFormData.agmDocumentFile
        ? await base64ToFile(
            savedFormData.agmDocumentFile.base64,
            savedFormData.agmDocumentFile.name,
            savedFormData.agmDocumentFile.type,
          )
        : null,

      otherDocumentFile: savedFormData.otherDocumentFile
        ? await base64ToFile(
            savedFormData.otherDocumentFile.base64,
            savedFormData.otherDocumentFile.name,
            savedFormData.otherDocumentFile.type,
          )
        : null,
    });
  } else if (currentStep === 6) {
    const savedDeclarationData = localStorage.getItem("declaration");

    if (!savedDeclarationData) return;

    const parsedDeclarationData = JSON.parse(savedDeclarationData);
    const savedFormData = parsedDeclarationData.formData;

    setDeclaration({
      ...savedFormData,
    });
  }
};

export const clearRegisterLocalStorage = async () => {
  const keys = [
    "cooperative",
    "address",
    "shareFinancial",
    "loanFinancial",
    "incomeFinancial",
    "auditFinancial",
    "taxFinancial",
    "committeeCooperative",
    "executiveCooperative",
    "committeeTableCooperative",
    "executiveTableCooperative",
    "shareMember",
    "documents",
    "declaration",
  ];

  keys.forEach((key) => localStorage.removeItem(key));
};
